import { colors } from 'fitify-ui'
import { typographyStyles } from 'fitify-ui/src/typography/generated/Typography'
import styled, { css } from 'styled-components'

export const StyledBadge = styled.span<{
  $variant?: 'default' | 'green' | 'blue'
  $size?: 'sm' | 'md'
}>`
  display: inline-flex;
  align-items: center;
  border-radius: 100px;

  ${(props) => {
    switch (props.$variant) {
      case 'green':
        return css`
          background-color: ${colors.Green50};
          color: ${colors.Green700};
        `
      case 'blue':
        return css`
          background-color: ${colors.Blue50};
          color: ${colors.Blue600};
        `
      default:
        return css`
          background-color: ${colors.Gray200};
          color: ${colors.Gray700};
        `
    }
  }}

  ${(props) => {
    switch (props.$size) {
      case 'sm':
        return css`
          padding: 3px 10px;
          ${typographyStyles('Special/Label 12')};
        `
      default:
        return css`
          padding: 6px 14px;
          ${typographyStyles('Special/Label 14')};
        `
    }
  }}
`

export const StyledBadges = styled.div<{ $gap?: number }>`
  display: flex;
  flex-wrap: wrap;
  gap: ${(props) => props.$gap ?? 8}px;
`
